import httpClient from './httpClient';
import { PricingQuoteResponse } from '@/types/pricing';
import { canonicalizeConfiguration } from '@/utils/configuration';

class PricingApi {
	async calculateQuote(
		payload: {
			productTypeId: string;
			variantId?: string | null;
			configuration: Record<string, string | number | null>;
		},
		signal?: AbortSignal
	) {
		const normalizedPayload = {
			...payload,
			configuration: canonicalizeConfiguration(payload.configuration),
		};
		const response = await httpClient.post<PricingQuoteResponse>('pricing/quote', normalizedPayload, {
			signal,
		});
		return response.data;
	}
}

export default new PricingApi();
